import ModalContact from './ModalContact'

export default ModalContact
